import { GcpBox, GcpCurrencyFormat, GcpTypography } from '@back-office/ui';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      margin: theme.spacing(1, 0),
      padding: theme.spacing(4, 7),
      background: theme.palette.common.chablis,
      border: '1px solid #F0D3D3',
      boxSizing: 'border-box',
      borderRadius: '20px',
      display: 'flex',
      justifyContent: 'space-between',
    },
  }),
  { name: 'VoidedTransaction' }
);

interface VoidedTransactionProps {
  amount: string;
  id: string;
  currency: string;
}

const VoidedTransaction: FC<VoidedTransactionProps> = (props) => {
  const { amount, id, currency } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <GcpBox className={classes.root}>
      <GcpBox display="flex" gap={3}>
        <GcpTypography paint="ceriseRed" variant="h3">
          {t('dialog.void')}
        </GcpTypography>
        <GcpTypography paint="hitGray" variant="body1">
          {t('transaction_list.void_id', { id })}
        </GcpTypography>
      </GcpBox>
      <GcpBox>
        <GcpCurrencyFormat
          paint="ceriseRed"
          suffix={currency}
          suffixVariant="body1"
          value={amount}
          valueVariant="h3"
        />
      </GcpBox>
    </GcpBox>
  );
};

export default VoidedTransaction;
